import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { AssessmentService } from 'src/app/services/assessment.service';
import { ProjectService } from 'src/app/services/project.service';
import { Assessment } from 'src/app/shared/models/assessment.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityService } from 'src/app/services/activity.service';
import { GenerateNewReportComponent } from 'src/app/shared/components/report-generation/generate-new-report/generate-new-report.component';

@Component({
    selector: 'app-view-assessment-conversation',
    templateUrl: './view-assessment-conversation.component.html',
    styleUrl: './view-assessment-conversation.component.scss',
    standalone: false
})
export class ViewAssessmentConversationComponent implements OnInit, OnDestroy {
  // --- Modal Templates ---
  @ViewChild('generateNewReport') generateNewReportModal!: GenerateNewReportComponent;
  @ViewChild('statusModal') statusModal!: TemplateRef<any>;

  // --- Route Params ---
  projectId!: number;
  assessmentId!: number;
  activityId!: number;

  // --- Data ---
  assessment!: Assessment;
  conversation!: any;
  conversationData: any = null;
  allowSpecial = false;

  // --- State & Loading ---
  loadingPage = true;
  loadingReport = false;
  progress = 0;
  startedUpload = false;
  startedRecord = false;

  // --- Modal Properties ---
  modalTitle = '';
  modalMessage = '';
  modalIcon = '';
  modalIconTrigger = 'loop';
  modalIconColors = '';

  // --- Subscriptions ---
  private reportDataSub?: Subscription;

  page_data: any = null;
  targetReportId: string | null = null;

  constructor(private route: ActivatedRoute, private router: Router, private projectService: ProjectService, private assessmentService: AssessmentService, private activityService: ActivityService, private authService: AuthService, private modalService: NgbModal) {}

  ngOnInit(): void {
    this.loadingPage = true;
    this.projectService.setLeftSideBar(true);
    this.allowSpecial = this.authService.currentClientValue.roles.includes('RESTRICTED');

    this.route.params.subscribe((params: any) => {
			this.projectId = params.projectid;
			this.assessmentId = params.assessmentid;
      this.activityId = params.conversationid;

      this.page_data = {
				project_id: this.projectId,
				case_id: this.assessmentId,
				conversation_id: this.activityId
			}

      this.getDetails();
    });
  }

  ngOnDestroy(): void {
    this.reportDataSub?.unsubscribe();
  }

  getDetails() {
    this.loadingPage = true;
    this.assessmentService.getProjectCaseActivity(this.projectId, this.assessmentId, this.activityId, { activity_type: 'conversation' }).subscribe({
      next: (response: any) => {
        this.assessment = response.case_data;
        const foundConversation = response.activity_data;

        if (foundConversation) {
          this.conversation = foundConversation;
          this.handleStatusCheck();
        } else {
          this.authService.toastErrorMessage('Conversation not found in this case.', 'Error');
          this.goBack();
        }
        this.loadingPage = false;
      },
      error: (err) => {
        this.authService.toastErrorMessage(err.message, 'Fetching Error');
        this.goBack();
      }
    });
  }

  handleStatusCheck() {
    if (this.conversation.status === 'COMPLETED') {
      this.loadingReport = true;
      
      this.reportDataSub = this.activityService.getProgressActivityData().subscribe(data => {
        this.progress = data.progress;
        if (data.data) {
          this.conversationData = data.data;
          this.loadingReport = false;
          this.reportDataSub?.unsubscribe();
        }
      });
      
      this.activityService.getProjectActivityData(this.projectId, this.assessmentId, this.activityId);
    }
  }

  chooseAction(file_type: string) {
    this.loadingPage = true;
    this.assessmentService.updateProjectCaseActivity(this.projectId, this.assessmentId, this.activityId, { activity_type: 'conversation' }, { file_type: file_type }).subscribe({
			next: () => {
				this.getDetails();
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Updating Error');
			}
		});
  }

  // --- Event handlers from child components ---
  onUploadStart(event: boolean) { this.startedUpload = event; }
  onRecordStart(event: boolean) { this.startedRecord = event; }
  onUploadComplete() {
    this.loadingPage = true;
    this.getDetails();
  }

  openGenerateNewReportModal() {
		this.generateNewReportModal.openModal(this.conversation.extra_content.analyze_version);
	}
  
  handleUpdateReports(event: any) {
		this.conversation = { ...this.conversation, ...event.entity };
		if (this.conversation.status === 'ANALYZING' || this.conversation.status === 'STARTED') {
			this.getDetails();
		} else {
			if (event.reportId) {
        this.targetReportId = event.reportId;
      }
		}
	}

  // --- Navigation ---
  goBack() {
    this.router.navigate(['/projects', this.projectId, 'assessment', this.assessmentId], { queryParams: { tab: 'assessments' } });
  }
}
